import { ApiProvider } from "@src/store/ApiProvider";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { handlePasswordManagerUnauthorized } from "./passwordManagerUnauthorized";

export interface IVendorFullData {
	vendorId: number;
	name: string;
	teamCode: string | null;
	crawlerId: number | null;
	url: string | null;
	eventHeadlinerId: number | null;
	vendorParentId: number | null;
	isActive: boolean;
	tM_System_ID: string | null;
}

const initialState: Array<IVendorFullData> = [];

const vendorsFullDataPath = "/passwordManager/Vendors/full-data";

const buildExternalUrl = () => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "https://qa.stagefront.com/password-manager/api";
	return `${baseUrl.replace(/\/$/, "")}/Vendors/full-data`;
};

const getAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
	};
};

export const { thunk: getVendorsFullData, slice: vendorsFullDataSlice } = getThunkAndSlice<
	Record<string, never>,
	Array<IVendorFullData>
>({
	initialState,
	path: vendorsFullDataPath,
	externalPath: buildExternalUrl,
	getHeaders: getAuthHeaders,
	onUnauthorized: handlePasswordManagerUnauthorized,
});
